<div class="mb-0100" *ngIf="anEventSyncEnabled">
  <h5 class="caps caps--light mt-0075 mb-0050 txt-12">Integrations</h5>
  <div class="mt-0050">
    <mat-slide-toggle
      [(ngModel)]="enableEventSync"
      (change)="toggleEventSync($event)"
      class="mb-0075"
    >
      Sync RSVPs from an Action Network event to this event
    </mat-slide-toggle>
    <ng-container *ngIf="enableEventSync && !selectedANEvent">
      <div class="scrollable-quicksearch--wrapper d-block">
        <mat-form-field class="col__ mb-0">
          <mat-label>Search events on Action Network&hellip;</mat-label>
          <input
            matInput
            type="text"
            [formControl]="searchInput"
            autocomplete="off"
          />
        </mat-form-field>
        <mat-selection-list
          dense
          (selectionChange)="onSyncEventSelected($event)"
          [multiple]="false"
          style="max-height: 200px"
          class="ab-list-group ab-list-group--scrollable-border bg-color--white border-1 bblr-0 bbrr-0 bbrr bblr pt-0 pb-0"
        >
          <app-spinner
            *ngIf="eventSyncResultsLoading"
            class="d-block mb-0200"
          ></app-spinner>

          <ng-container
            *ngIf="!eventSyncResultsLoading && !filteredAnEvents.length"
          >
            <mat-list-option>
              <p class="color--gray">No results</p>
            </mat-list-option>
          </ng-container>
          <ng-container
            *ngIf="!eventSyncResultsLoading && filteredAnEvents.length"
          >
            <mat-list-option
              *ngFor="let event of filteredAnEvents; let i = index"
              [togglePosition]="'after'"
              [value]="event"
              class="txt-16 ab-list-item ab-list-item--an-event p-0100 pt-0075 pb-0075"
            >
              <div class="flex flexAlign-start flexJustify-between">
                <div class="info">
                  <button
                    class="mimic-link"
                    (click)="onEventLinkClick($event, event.permalink)"
                  >
                    {{ event.administrativeTitle || event.title }}
                  </button>
                  <div
                    class="info--date txt-12 color--gray lh-normal normal-wrap"
                  >
                    {{ event | eventStartEndTime }}
                    <ng-container *ngIf="event.timezone">{{
                      event.timezone
                    }}</ng-container>
                  </div>
                </div>
                <button
                  class="btn btn--white pt-0050 pb-0050 pl-0075 pr-0075"
                  (click)="onEventSyncButtonClicked(event)"
                >
                  Sync
                </button>
              </div>
            </mat-list-option>
          </ng-container>
        </mat-selection-list>
        <div
          class="p-0100 pt-0062 pb-0062 bg-color--gray--000 border-1 bbrr bblr border-top-0"
        >
          <span class="color--gray txt-13"
            >Displaying your 50 most recently created events, sorted by date
            created.</span
          >
        </div>
      </div>
    </ng-container>
  </div>
  <ng-container *ngIf="selectedANEvent">
    <div
      class="selected-event table p-0100 flex flexAlign-center flexJustify-between"
    >
      <div
        class="selected-event__info flex flexAlign-center flexJustify-between"
      >
        <i
          class="far fa-calendar selected-event__info-icon color--gray--005"
        ></i>
        <div class="selected-event__info-text">
          <button
            class="mimic-link"
            (click)="onEventLinkClick($event, selectedANEvent.permalink)"
          >
            {{ selectedANEvent.administrativeTitle || selectedANEvent.title }}
          </button>
          <div class="selected-event__date txt-12 color--gray">
            {{ selectedANEvent | eventStartEndTime }}
            <ng-container *ngIf="selectedANEvent.timezone">{{
              selectedANEvent.timezone
            }}</ng-container>
          </div>
        </div>
      </div>
      <button
        class="color--red border-0 bg-color--trans"
        (click)="unsyncANEvent()"
        matTooltip="Note: disabling event sync will not revert any existing changes, but will prevent synchronization going forward"
      >
        <i class="far fa-circle-xmark"></i>
      </button>
    </div>
  </ng-container>
</div>
